import {Component} from '@angular/core';

import {AbstractItemView} from '../abstract-item-view';

@Component({
  selector: 'lt-item-icon-view',
  templateUrl: './item-icon-view.component.html',
  styleUrls: ['./item-icon-view.component.scss', '../item-view.scss'],
})
export class ItemIconViewComponent extends AbstractItemView {
  get data() {
    return <string>this.item.data;
  }
}
